import api from "./api";

const assignmentService = {
  // Assignments
  getAssignments: async (params) => {
    const res = await api.get("/assignment/get-all-assignments", { params });
    return res?.data?.data;
  },

  getAssignmentCourseNames: (params = {}) =>
    api.get("/assignment/courses-names", {
      params,
    }),

  getAssignmentSubjectNames: (params = {}) =>
    api.get("/assignment/subject-names", {
      params,
    }),

  getStudentsSubmittedAssignments: (params = {}) =>
    api.get("/assignment-submission/students-submitted-assignments", {
      params,
    }),

  gradeSubmission: (submissionId, data = {}) =>
    api.put(`/assignment-submission/grade/${submissionId}`, data),

  getDepartmentAssignmentsOfHod: (params = {}) => {
  //  console.log("Calling API: /teacher/department-assignments-of-hod", params);
 //   return api.get("/teacher/department-assignments-of-hod", { params });
    return api.get("/assignment/get-all-assignments", { params });
 
  },

  getAssignmentById: (id) => api.get(`/assignments/${id}`),

  createAssignment: (assignmentData) => {
    const formData = new FormData();
    
    // Add all fields to FormData
    Object.keys(assignmentData).forEach((key) => {
      if (key === "attachments" && assignmentData[key]) {
        // Handle multiple file attachments
        if (Array.isArray(assignmentData[key])) {
          assignmentData[key].forEach((file) => {
            formData.append("attachments", file);
          });
        } else if (assignmentData[key] instanceof File) {
          formData.append("attachments", assignmentData[key]);
        }
      } else if (key === "attachment" && assignmentData[key]) {
        // Backward compatibility for single file
        if (assignmentData[key] instanceof File) {
          formData.append("attachments", assignmentData[key]);
        } else if (Array.isArray(assignmentData[key]) && assignmentData[key].length > 0) {
          assignmentData[key].forEach((file) => {
            formData.append("attachments", file);
          });
        }
      } else if (key === "maxMarks" || key === "maxGrades") {
        const value = assignmentData[key];
        if (value === null) {
          formData.append(key, "");
        } else if (value !== undefined && value !== "") {
          formData.append(key, value);
        }
      } else if (assignmentData[key] !== null && assignmentData[key] !== undefined && assignmentData[key] !== "") {
        // Convert dates to ISO string format
        if (assignmentData[key] instanceof Date) {
          formData.append(key, assignmentData[key].toISOString());
        } else {
          formData.append(key, assignmentData[key]);
        }
      }
    });
    
    return api.post("/assignment/create-assignment", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  updateAssignment: (id, assignmentData) => {
    const formData = new FormData();
    
    // Add all fields to FormData
    Object.keys(assignmentData).forEach((key) => {
      if (key === "attachments" && assignmentData[key]) {
        // Handle multiple file attachments
        if (Array.isArray(assignmentData[key])) {
          assignmentData[key].forEach((file) => {
            formData.append("attachments", file);
          });
        } else if (assignmentData[key] instanceof File) {
          formData.append("attachments", assignmentData[key]);
        }
      } else if (key === "attachment" && assignmentData[key]) {
        // Backward compatibility for single file
        if (assignmentData[key] instanceof File) {
          formData.append("attachments", assignmentData[key]);
        } else if (Array.isArray(assignmentData[key]) && assignmentData[key].length > 0) {
          assignmentData[key].forEach((file) => {
            formData.append("attachments", file);
          });
        }
      } else if (key === "maxMarks" || key === "maxGrades") {
        const value = assignmentData[key];
        if (value === null) {
          formData.append(key, "");
        } else if (value !== undefined && value !== "") {
          formData.append(key, value);
        }
      } else if (assignmentData[key] !== null && assignmentData[key] !== undefined && assignmentData[key] !== "") {
        // Convert dates to ISO string format
        if (assignmentData[key] instanceof Date) {
          formData.append(key, assignmentData[key].toISOString());
        } else {
          formData.append(key, assignmentData[key]);
        }
      }
    });
    
    return api.put(`/assignment/update-assignment?id=${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  deleteAssignment: (id) => api.delete(`/assignment/delete-assignment?id=${id}`),

  // Submissions
  submitAssignment: (assignmentId, submissionData = {}) => {
    const formData = new FormData();
    formData.append("assignmentId", String(assignmentId));

    const textParts = [];
    if (submissionData.title) textParts.push(String(submissionData.title).trim());
    if (submissionData.comments) textParts.push(String(submissionData.comments).trim());
    if (submissionData.submissionText) textParts.push(String(submissionData.submissionText).trim());
    const submissionText = textParts.filter(Boolean).join("\n\n");
    if (submissionText) {
      formData.append("submissionText", submissionText);
    }

    const files = submissionData.files || submissionData.attachments || [];
    if (Array.isArray(files)) {
      files.forEach((file) => {
        if (file) formData.append("attachments", file);
      });
    }

    return api.post("/assignment-submission/submit", formData);
  },

  getSubmissions: (assignmentId) =>
    api.get(`/assignments/${assignmentId}/submissions`),

  getSubmissionById: (assignmentId, submissionId) =>
    api.get(`/assignments/${assignmentId}/submissions/${submissionId}`),

  approveSubmission: (submissionId, data) =>
    api.post(`/assignments/submissions/${submissionId}/approve`, data),

  rejectSubmission: (submissionId, data) =>
    api.post(`/assignments/submissions/${submissionId}/reject`, data),

  // Materials
  getMaterials: (params) => api.get("/material/getAll", { params }),

  getMaterialById: (id) => api.get(`/materials/${id}`),

  createMaterial: (materialData) => {
    const formData = new FormData();
    
    // Map to API expected field names
    formData.append("name", materialData.name || materialData.title || "");
    formData.append("details", materialData.details || materialData.description || "");
    formData.append(
      "departmentId",
      materialData.departmentId || materialData.department || ""
    );
    formData.append("courseId", materialData.courseId || materialData.course || "");
    formData.append("subjectId", materialData.subjectId || materialData.subject || "");
    formData.append("classId", materialData.classId || materialData.class || "");
    
    // Handle file upload - API expects "files" field name
    if (materialData.files && Array.isArray(materialData.files)) {
      materialData.files.forEach((file, index) => {
        if (file instanceof File) {
          formData.append("files", file);
        }
      });
    } else if (materialData.file) {
      // Fallback for single file
      if (materialData.file instanceof File) {
        formData.append("files", materialData.file);
      } else if (Array.isArray(materialData.file) && materialData.file.length > 0) {
        formData.append("files", materialData.file[0]);
      }
    }
    
    // Debug: Log what we're sending (in development only)
    if (process.env.NODE_ENV === 'development') {
      console.log('Creating material with FormData fields:', {
        name: materialData.name || materialData.title,
        details: materialData.details || materialData.description,
        subjectId: materialData.subjectId || materialData.subject,
        classId: materialData.classId || materialData.class,
        filesCount: materialData.files?.length || (materialData.file ? 1 : 0),
        fileNames: materialData.files?.map(f => f.name) || (materialData.file?.name ? [materialData.file.name] : [])
      });
    }
    
    return api.post("/material/create", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  updateMaterial: (id, materialData) => {
    const formData = new FormData();
    
    // Include materialId in the payload (required by backend)
    formData.append("materialId", id?.toString() || "");
    
    // Map to API expected field names
    formData.append("name", materialData.name || materialData.title || "");
    formData.append("details", materialData.details || materialData.description || "");
    formData.append(
      "departmentId",
      materialData.departmentId || materialData.department || ""
    );
    formData.append("courseId", materialData.courseId || materialData.course || "");
    formData.append("subjectId", materialData.subjectId || materialData.subject || "");
    formData.append("classId", materialData.classId || materialData.class || "");
    
    // Handle file upload (optional for update) - API expects "files" field name
    if (materialData.files && Array.isArray(materialData.files)) {
      materialData.files.forEach((file, index) => {
        if (file instanceof File) {
          formData.append("files", file);
        }
      });
    } else if (materialData.file) {
      // Fallback for single file
      if (materialData.file instanceof File) {
        formData.append("files", materialData.file);
      } else if (Array.isArray(materialData.file) && materialData.file.length > 0) {
        formData.append("files", materialData.file[0]);
      }
    }
    
    // Debug: Log what we're sending (in development only)
    if (process.env.NODE_ENV === 'development') {
      console.log('Updating material with FormData fields:', {
        materialId: id,
        name: materialData.name || materialData.title,
        details: materialData.details || materialData.description,
        subjectId: materialData.subjectId || materialData.subject,
        classId: materialData.classId || materialData.class,
        filesCount: materialData.files?.length || (materialData.file ? 1 : 0),
        fileNames: materialData.files?.map(f => f.name) || (materialData.file?.name ? [materialData.file.name] : [])
      });
    }
    
    return api.put(`/material/update?id=${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  deleteMaterial: (id) => api.delete(`/material/delete?id=${id}`, {
    data: { materialId: id }
  }),

  downloadMaterial: (id) =>
    api.get(`/materials/${id}/download`, {
      responseType: "blob",
    }),
};

export default assignmentService;
